module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "life_skills_curriculum.232e3e15.png";